export default __webpack_public_path__ + "static/media/counter.d911138e.svg";